'use strict';

module.exports.PROTECTOR_REQUIRED = 'No protector provided with private network enforced';